
import Vue, { VNode, CreateElement } from 'vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VAutocomplete from 'vuetify/lib/components/VAutocomplete/VAutocomplete';

const base = Vue.extend({ mixins: [VAutocomplete] });
export default base.extend({
    name: 'emphasized-select',
    props: {
        // set filled true, as this is the select style we want for emphasized selects
        filled: {
            type: Boolean,
            default: true
        },
        dense: {
            type: Boolean,
            default: true
        },
        prependIcon: {
            type: String,
            default(): string | undefined {
                return 'far fa-bolt';
            }
        },
        appendIcon: {
            type: String,
            default(): string {
                return 'fa-solid fa-chevron-down';
            }
        },
        height: {
            type: [Number, String],
            default: undefined
        },
        fullWidth: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: undefined
        },
        label: {
            type: String,
            default: ''
        }
    },
    computed: {
        classes(): object {
            return {
                ...VAutocomplete.options.computed.classes.call(this),
                'base-select': true,
                'emphasized-select': true
            };
        }
    },
    render(h: CreateElement): VNode {
        const autocomplete = h(
            VAutocomplete,
            {
                class: this.classes,
                props: {
                    ...this.$props,
                    filled: this.filled,
                    dense: this.dense,
                    prependIcon: this.prependIcon,
                    appendIcon: this.appendIcon,
                    height: this.height,
                    fullWidth: this.fullWidth,
                    placeholder: this.placeholder,
                    label: ''
                },
                on: this.$listeners,
                scopedSlots: this.$scopedSlots,
                attrs: this.$attrs
            },
            this.$slots.default
        );

        return h('div', { class: 'select-wrapper' }, [
            this.label
                ? h('div', { class: 'select-title' }, this.label)
                : null,
            autocomplete
        ]);
    }
});
